@if (accountingPlan) {
  <panel width="400">
    <h1>{{ 'company.accounting-plans.edit-payment-interval' | translate }}</h1>
    <section>
      <custom-select [selectList]="availableIntervals" [(value)]="selectedInterval" [allowAutoFocus]="false" [required]="true" [label]="'accounting.edit-payment-interval.new-interval' | translate" (valueChange)="generateBillingPlan()" />
      <custom-select [selectList]="availableMaxPaymentNumbers" [(value)]="maxNumberOfPayments" [placeholder]="'accounting.edit-payment-interval.no-max-payments-selected' | translate" [label]="'accounting.edit-payment-interval.max-payments' | translate" (valueChange)="generateBillingPlan()" />
    </section>
    <section>
      <button ghost (click)="cancel()" [ignoreValidation]="true">{{ 'general.cancel' | translate }}</button>
      <button confirm (click)="updateBillingPlan()" [label]="'general.save' | translate"></button>
    </section>
  </panel>
  @if (productPlan && accountingPlan && accountingPlan.startDate) {
    <panel width="600">
      <h1>{{ 'ledger-posts.header' | translate }}</h1>
      @if (generatingPlan) {
        <skeletons [defaultSkeletons]="10" />
      }
      <ledger-posts [hidden]="generatingPlan" #ledgerPosts [editMode]="true" [productPlans]="[productPlan]" [displayProductName]="false" [accountingPlan]="accountingPlan" [allowChangingTotalValue]="false" />
    </panel>
  }
}
